'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _reactRedux = require('react-redux');

var _reselect = require('reselect');

var _permissionUtil = require('../../../common/permissions/permissionUtil');

var _documentModeSelector = require('./documentModeSelector');

var _permissionsService = require('../../utils/permissions/permissionsService');

var _currentlyEditingSelector = require('../../element/selection/currentlyEditingSelector');

var _ElementCreateUtil = require('./elementCreate/ElementCreateUtil');

var _ElementCreateUtil2 = _interopRequireDefault(_ElementCreateUtil);

require('./MobileFloatingTool.scss');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

// Components


// Utils
// Lib
var floatingToolSelector = (0, _reselect.createSelector)(_documentModeSelector.inboxChildrenSelector, _permissionsService.currentBoardUserPermissionsSelector, _currentlyEditingSelector.isCurrentlyEditing, function (inboxChildren, currentBoardPermissions, isEditing) {
    return {
        inboxCount: inboxChildren.size,
        showCreateButton: (0, _permissionUtil.canWrite)(currentBoardPermissions) && !isEditing
    };
});

// Styles


// Selectors


var MobileFloatingTool = function MobileFloatingTool(props) {
    return _react2.default.createElement(
        'div',
        { className: 'MobileFloatingTool' },
        _react2.default.createElement(_ElementCreateUtil2.default, props)
    );
};

MobileFloatingTool.propTypes = {
    currentBoardId: _propTypes2.default.string.isRequired,
    isEditable: _propTypes2.default.bool
};

exports.default = (0, _reactRedux.connect)(floatingToolSelector)(MobileFloatingTool);


//////////////////
// WEBPACK FOOTER
// ./src/client/workspace/mobile/MobileFloatingTool.js
// module id = 2202
// module chunks = 0